"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSET_CATEGORY_KEY = 'base';
exports.ASSET_COMPONENT_KEY = 'asset';